import '@fancyapps/fancybox';

import $ from 'jquery';

class Faq {
	constructor($el) {
		// module vars declarations
		this.$el = $el;
        this.$item = this.$el.find(".faq__item");
		this.$cta = this.$el.find("button.faq__tab-cta");
		this.toggleClass = "expand";
		// methods initialization
		this.init();
	}

	init() {
		this.toggleFaqBody();
	}

    toggleFaqBody() {
        const self = this;
        this.$cta.on("click", function () {
            const $currentItem = $(this).closest(".faq__item");
            $currentItem.toggleClass(self.toggleClass);
            $currentItem.siblings().removeClass(self.toggleClass);
        });
    }
}

export default Faq;